export default {
    positionId: 'Position ID',
    name: 'Position',
    shortName: 'Acronym',
    searchText: 'Search by Position',
    search: 'search'
}
